import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'row-reverse',
            gap: remCalc(8),
        },
        label: {
            width: 'fit-content',
            alignItems: 'center',
            marginLeft: remCalc(0),
            textStyle: 'body-small',
            color: 'text.default',
        },
        control: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: remCalc(16),
            height: remCalc(16),
            padding: remCalc(2.5),
            borderWidth: '1px !important',
            borderStyle: 'solid',
            borderColor: 'border.neutral.highlight !important',
            bg: 'background.base.default',
            borderRadius: 'medium',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-md, rgba(19, 24, 58, 0.16))',

            _checked: {
                bg: 'checkbox.bg.checked',

                _hover: {
                    bg: 'checkbox.bg.checkedHover',
                },
                _disabled: {
                    bg: 'checkbox.bg.checkedDisabled',
                    _hover: {
                        bg: 'checkbox.bg.checkedDisabled',
                    },
                },
            },
            _hover: {
                bg: 'background.base.elevated',
                _checked: {},
            },

            _disabled: {
                bg: 'background.base.deep',

                _hover: {
                    bg: 'background.base.deep',
                },
            },
        },
        icon: {
            boxSize: remCalc(10),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'foreground.neutral.inverse',
            _checked: {
                color: 'foreground.neutral.inverse',
            },
            _hover: {
                bg: 'none',
                borderColor: 'border.dark',
                _checked: {
                    bg: 'none',
                    borderColor: 'border.dark',
                },
            },
        },
        '.chakra-checkbox__control[data-focus]': {
            boxShadow:
                'inset 0 0 0 1px var(--chakra-colors-background-base-default), 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 2px var(--chakra-shadows-accent-lg)',
        },
    },
    variants: {
        secondary: {
            container: {
                backgroundColor: 'background.default',
            },
        },
        row: {
            container: {
                flexDirection: 'row',
            },
        },
    },
    defaultProps: {
        size: 'none',
    },
}
